var React = require('react');

function ExternalLink (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"iconAsset 161"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("path",{"fill":"currentColor","d":"M10,7.28a1,1,0,0,0-1,1V12H2V5H5.5a1,1,0,0,0,0-2H1A1,1,0,0,0,0,4v9a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V8.28A1,1,0,0,0,10,7.28Z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M13.63.62A1,1,0,0,0,12.71,0H7.38a1,1,0,1,0,0,2h2.91L4.55,7.7a1,1,0,0,0,.71,1.71A1,1,0,0,0,6,9.12L11.7,3.41V6.27a1,1,0,0,0,2,0v-5s0,0,0-.07A1,1,0,0,0,13.63.62Z","key":1})]))]);
}

ExternalLink.defaultProps = {"viewBox":"0 0 13.71 14.04"};

module.exports = ExternalLink;

ExternalLink.default = ExternalLink;
